import { StanButton, StanCard } from '@/components';

export function AmbassadorBanner() {
    return (
        <StanCard>
            <div className='flex w-full flex-col items-center justify-center gap-8 text-center md:flex-row md:text-left'>
                <img
                    src='https://admin.staging.stan.store/images/referrals/ambassador_half_phone.png'
                    alt='Stan Ambassador'
                    className='h-auto w-full max-w-xs shrink-0'
                />
                <div className='flex w-full flex-col items-center gap-4 md:w-auto md:items-start'>
                    <h2 className='text-dark text-heading-h2'>Ready to Earn More with Stan?</h2>
                    <p className='text-gray text-body-lg'>Scale your business as a Stan Ambassador.</p>
                    <a
                        href='https://partnerships.stan.store/'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='w-full md:w-auto'
                    >
                        <StanButton name='apply-ambassador' color='primary' size='md' className='w-full md:w-auto'>
                            Apply Now!
                        </StanButton>
                    </a>
                </div>
            </div>
        </StanCard>
    );
}
